import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AppShell from "@/components/AppShell";
import Dashboard from "@/pages/Dashboard";
import StudentsPage from "@/pages/Students";
import StaffPage from "@/pages/Staff";
import AttendancePage from "@/pages/Attendance";
import FeesPage from "@/pages/Fees";
import HomeworkPage from "@/pages/Homework";
import ExamsPage from "@/pages/Exams";
import TimetablePage from "@/pages/Timetable";
import AnnouncementsPage from "@/pages/Announcements";
import AIAssistantPage from "@/pages/AIAssistant";
import SettingsPage from "@/pages/Settings";
import InvitesPage from "@/pages/Invites";
import ChildrenPage from "@/pages/Children";
import AdminConsole from "@/pages/AdminConsole";
import OwnerConsole from "@/pages/OwnerConsole";
import Landing from "@/pages/Landing";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground">
        <div className="animate-pulse text-sm tracking-widest uppercase">Loading School OS…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function Root() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Landing />;
  return <Navigate to="/dashboard" replace />;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Root />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route element={<Protected><AppShell /></Protected>}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/students" element={<StudentsPage />} />
              <Route path="/staff" element={<StaffPage />} />
              <Route path="/attendance" element={<AttendancePage />} />
              <Route path="/fees" element={<FeesPage />} />
              <Route path="/homework" element={<HomeworkPage />} />
              <Route path="/exams" element={<ExamsPage />} />
              <Route path="/timetable" element={<TimetablePage />} />
              <Route path="/announcements" element={<AnnouncementsPage />} />
              <Route path="/ai" element={<AIAssistantPage />} />
              <Route path="/invites" element={<InvitesPage />} />
              <Route path="/children" element={<ChildrenPage />} />
              <Route path="/admin" element={<AdminConsole />} />
              <Route path="/owner" element={<OwnerConsole />} />
              <Route path="/settings" element={<SettingsPage />} />
            </Route>
            <Route path="*" element={<Root />} />
          </Routes>
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
